import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UiSnackbarIntl } from '@uipath/angular/components/ui-snackbar';

import { takeUntil } from 'rxjs/operators';

@Injectable()
export class UiSnackIntl extends UiSnackbarIntl {
    constructor(
        protected _translateService: TranslateService,
    ) {
        super();

        _translateService
            .stream([
                'snackbar_close_aria_label',
            ])
            .pipe(
                takeUntil(this._destroyed$),
            )
            .subscribe(this._updateLabels);
    }

    private _updateLabels = ({
        snackbar_close_aria_label,
    }: Record<string, string>) => {
        this.closeAriaLabel = snackbar_close_aria_label;
    }
}
